export default {
  sections: {
    settings: 'Einstellungen',
  },
  status_switch: {
    label: 'Loyalitätsprogramm',
    on: 'An',
    off: 'Aus',
    description: 'Kunden sammeln bei jeder Bestellung Cashback und können es an der Kasse einlösen.',
    description_missing: 'Speichern Sie die Einstellungen unten, um Ihr Loyalitätsprogramm zu starten.',
  },
  alerts: {
    off: 'Ihr Loyalitätsprogramm ist ausgeschaltet. Kunden sammeln bei neuen Bestellungen kein Cashback, können ihre Punkte nicht einlösen und sehen das Programm in Ihrem Shop nicht. Bereits gesammelte Punkte bleiben erhalten und verfallen wie gewohnt.',
    expired: 'Ihr Loyalitätsprogramm ist abgelaufen. Schalten Sie es ein, um es ohne Enddatum neu zu starten.',
  },
  form: {
    title: {
      label: 'Titel',
    },
    percentage: {
      label: 'Prozentsatz der Rückerstattung',
      validation: {
        required: 'Cashback-Prozentsatz ist erforderlich',
        min: 'Cashback Prozentsatz Mindestwert ist {{value}}%',
        max: 'Cashback Prozentsatz maximaler Wert ist {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Wie viele Tage wollen Sie Ihren Kunden geben, um die Punkte zu nutzen?',
      validation: {
        min: 'Minimum {{value}} Tage für Punkteverfall',
      },
    },
    min_spending_limit: {
      label: 'Minimale Ausgabengrenze für Cashback',
      validation: {
        required: 'Minimale Ausgabengrenze ist erforderlich',
        gt_zero: 'Die minimale Ausgabengrenze muss größer als 0 sein',
        lt_max_spending_limit: 'Die minimale Ausgabengrenze muss niedriger sein als die maximale Ausgabengrenze',
      },
    },
    max_spending_limit: {
      label: 'Maximale Ausgabengrenze für Cashback',
      validation: {
        required: 'Maximale Ausgabengrenze ist erforderlich',
        gt_min_spending_limit: 'Die maximale Ausgabengrenze muss höher sein als die minimale Ausgabengrenze',
      },
    },
    has_welcome_bonus: {
      label: 'Willkommensbonus',
      description: 'Geben Sie Ihren Erstkunden einen Cashback-Bonus für die Anmeldung',
    },
    welcome_bonus: {
      label: 'Wert des Willkommensbonus',
    },
    has_end_date: {
      label: 'Dauer',
      options: {
        false: 'Unendlich',
        true: 'Mit konkretem Enddatum',
      },
    },
    end_date: {
      label: 'Enddatum',
    },
    has_mobile_app_signup_bonus: {
      label: 'Mobile-App-Anmeldebonus',
      description: 'Belohne Nutzer, die sich zum ersten Mal über die Mobile App einloggen',
    },
    mobile_app_signup_bonus: {
      label: 'Bonusbetrag',
    },
  },
  tags: {
    inactive: 'Nicht aktiv',
    active: 'Aktiv',
    expired: 'Abgelaufen',
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    changes_got_saved: 'Änderungen wurden gespeichert',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    turned_on: 'Loyalitätsprogramm eingeschaltet',
    turned_off: 'Loyalitätsprogramm ausgeschaltet',
  },
};
